import { render, staticRenderFns } from "./FuTableColumnSelectDialog.vue?vue&type=template&id=61cbb5a4&"
import script from "./FuTableColumnSelectDialog.vue?vue&type=script&lang=js&"
export * from "./FuTableColumnSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports